export default __webpack_public_path__ + "static/media/dashboard_tick_icon_new.50a3101f.svg";